
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widgets/qr",
      function () {
        return require("private-next-pages/widgets/qr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widgets/qr"])
      });
    }
  